// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as PlaceholderDefault } from '../../../../../ui-v3/src/assets/icons/default/general/placeholder.svg?react';
import { ReactComponent as PlaceholderSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/PLACEHOLDER.svg?react';
import { createIcons } from '../../Icon';
const PlaceholderIcon = /* @__PURE__ */ createIcons('Placeholder', {
    default: PlaceholderDefault,
    solid: PlaceholderSolid
});
PlaceholderIcon.supportedTypes = [
    'default',
    'solid'
];
PlaceholderIcon.category = 'general';
export default PlaceholderIcon;
